module.exports = __webpack_public_path__ + "img/belt-diagram.32aef232.png";